/*
  FV の直下の「ゆめさくエンジニア」の話の節 (components/StorySection.tsx) の CSS。前の紹介動画の見た目を引き継ぐ。
  - 地は白に墨の点 (動画の点の地)。/women の緑の着せ替え (sec-women-line.ts) は節の地を !important で塗るので、この節は自前の class で地を持つ
  - 字は明朝の 700 だけ (スマホの h2 は土台の決まりどおり 900)。明朝の 900 はスマホの h2 の字しか書き出しの束に無いので、ほかに 900 を使わない
  - 緑 #05B45B は線と棒だけで、上に字を載せない。黄は答えの 1 か所 (.hx-hl) だけ
  - 下の白抜きの英字は飾り。ごくゆっくり流し (1 周 160 秒)、動きを減らす設定では止める
  - スマホ (767px 以下) は札を横の列のまま送る (受講生の声と同じ data-hx-row)。768px から上は 3 列の格子で、02 の札だけ 2 列ぶん
*/
const S = ".hp .hx-story";
const GREEN = "#05B45B";
const DOTS = "radial-gradient(circle,rgba(20,35,26,.16) 1.2px,transparent 1.6px) 0 0/28px 28px";

export const STORY_CSS = `
${S}{position:relative;overflow:hidden;padding-bottom:0;background:${DOTS},#fff}
${S} .hx-st-nw{display:inline-block}
${S} .hx-st-q{background:linear-gradient(${GREEN},${GREEN}) 0 100%/100% 4px no-repeat;padding-bottom:4px;box-decoration-break:clone;-webkit-box-decoration-break:clone}
${S} .hx-st-ans{--font-body-ja:var(--mincho);display:flex;flex-wrap:wrap;align-items:center;column-gap:.2em;row-gap:6px;margin:20px 0 0;font-weight:700;font-size:clamp(19px,5.2vw,28px);line-height:1.5;letter-spacing:.01em;color:var(--ink)}

/* 札の列。PC は 3 列の格子 */
${S} .hx-st-box{margin-top:var(--gap)}
${S} .hx-st-row{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:16px;margin:0;padding:0;list-style:none}
${S} .hx-st-card{display:flex;flex-direction:column;gap:12px;min-width:0;margin:0;padding:18px 20px 22px;border:1px solid #DCDCD3;border-radius:6px;background:#fff}
${S} .hx-st-prog{display:flex;gap:4px;margin-bottom:4px}
${S} .hx-st-prog i{flex:1;height:3px;border-radius:2px;background:#E4E4DC}
${S} .hx-st-prog i.on{background:${GREEN}}
${S} .hx-st-k{margin:0;font-weight:700;font-size:13px;line-height:1.6;color:var(--sub)}
${S} .hx-st-big{--font-body-ja:var(--mincho);margin:0;font-weight:700;font-size:clamp(20px,5.4vw,24px);line-height:1.45;color:var(--ink)}

/* 02 不安 → 言い切り。PC は横に並べて矢印でつなぐ */
${S} .hx-st-c2{grid-column:span 2;display:grid;grid-template-columns:minmax(0,1fr) auto minmax(0,1.1fr);grid-template-rows:auto 1fr;column-gap:20px;row-gap:12px;align-items:center}
${S} .hx-st-c2>.hx-st-prog{grid-column:1/-1;align-self:start}
${S} .hx-st-c2a{display:flex;flex-direction:column;gap:10px}
${S} .hx-st-qs{display:flex;flex-direction:column;gap:6px;margin:0;padding:0;list-style:none}
${S} .hx-st-qs li{display:flex;align-items:baseline;gap:8px;padding:8px 12px;border:1px solid #DCDCD3;border-radius:6px;background:#FAFAF6;font-weight:700;font-size:14px;line-height:1.5;color:var(--ink)}
${S} .hx-st-qs b{--font-body-ja:var(--mono);flex:none;font-weight:600;font-size:13px;color:var(--ink)}
${S} .hx-st-to{display:grid;place-items:center;width:36px;height:36px;border-radius:50%;background:var(--ink);color:#fff}
${S} .hx-st-c2b{font-size:clamp(20px,5.4vw,26px)}

/* 03 読む、書く、動かす → 積み上げ。隣の 02 の札が行の高さを決めるので、余りは 3 つの手順と「積み上げる」の間に出す。「積み上げる」と言語の札は下にまとめ、04 以下の札の注記や枠と同じく札の下端にそろえる */
${S} .hx-st-c3b{margin-top:auto}
${S} .hx-st-steps{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:6px;margin:0;padding:0;list-style:none;counter-reset:st}
${S} .hx-st-steps li{position:relative;display:flex;flex-direction:column;align-items:flex-start;gap:2px;padding:10px;border-top:3px solid var(--ink);background:#FAFAF6}
${S} .hx-st-sj{--font-body-ja:var(--mincho);font-weight:700;font-size:17px;line-height:1.4;white-space:nowrap}
${S} .hx-st-tags{display:flex;flex-wrap:wrap;gap:5px;margin:0;padding:0;list-style:none}
${S} .hx-st-tags li{--font-body-ja:var(--mono);padding:2px 9px;border:1.5px solid var(--ink);border-radius:999px;background:var(--ink);color:#fff;font-weight:600;font-size:11px;line-height:1.5;letter-spacing:.04em}
${S} .hx-st-tags li.o{background:#fff;color:var(--ink)}

/* 04 数字。数えた日の注記は下に */
${S} .hx-st-nums{display:flex;flex-direction:column;gap:14px;margin:0;padding:0;list-style:none}
${S} .hx-st-nums li{display:flex;flex-wrap:wrap;align-items:baseline;column-gap:10px}
${S} .hx-st-num{--font-body-ja:var(--mincho);font-weight:700;font-size:clamp(40px,11vw,48px);line-height:1.1;letter-spacing:-.01em;color:var(--ink);font-variant-numeric:lining-nums}
${S} .hx-st-unit{font-weight:700;font-size:14px;color:var(--ink)}
${S} .hx-st-gauge{flex:0 0 100%;height:8px;margin-top:6px;background:repeating-linear-gradient(90deg,transparent 0 calc(10% - 2px),rgba(255,255,255,.9) calc(10% - 2px) 10%),${GREEN};border-radius:1px}
${S} .hx-st-note{margin:auto 0 0;font-size:12px;line-height:1.6;color:var(--sub)}

/* 05 受講料 */
${S} .hx-st-chip{align-self:flex-start;margin:0;padding:2px 12px;border-radius:999px;background:var(--ink);color:#fff;font-weight:700;font-size:13px;line-height:1.6}
${S} .hx-st-price{--font-body-ja:var(--mincho);margin:0;font-weight:700;font-size:clamp(30px,8.4vw,38px);line-height:1.2;letter-spacing:-.01em;color:var(--ink);white-space:nowrap}
${S} .hx-st-mid{--font-body-ja:var(--mincho);margin:0;font-weight:700;font-size:18px;line-height:1.5;color:var(--ink)}
${S} .hx-st-box2{display:flex;align-items:flex-start;gap:10px;margin:auto 0 0;padding:12px 14px;border-radius:6px;background:var(--ink);color:#fff;font-weight:700;font-size:13px;line-height:1.6}
${S} .hx-st-ck{flex:none;display:grid;place-items:center;width:22px;height:22px;margin-top:1px;border-radius:50%;background:#fff;color:var(--ink)}

/* 06 まず触れる */
${S} .hx-st-btn{display:inline-flex;align-items:center;justify-content:space-between;gap:8px;align-self:stretch;min-height:52px;padding:8px 18px;border-radius:999px;background:var(--ink);color:#fff;font-weight:900;font-size:clamp(14px,3.8vw,16px);line-height:1.4;word-break:auto-phrase;text-decoration:none;transition:transform .15s ease,background-color .15s ease}
${S} .hx-st-btn svg{flex:none}
${S} .hx-st-btn:hover{background:#000}
${S} .hx-st-bnote{margin:-4px 0 0;font-size:12px;line-height:1.6;color:var(--sub);text-align:center}
${S} .hx-st-btn:active{transform:scale(.98)}
${S} .hx-st-btn:focus-visible{outline:2px solid var(--focus-ring);outline-offset:3px}
${S} .hx-st-end{--font-body-ja:var(--mincho);margin:auto 0 0;font-weight:700;font-size:15px;line-height:1.6;color:var(--ink)}

/* 下を流れる白抜きの英字 (飾り) */
@keyframes hx-st-flow{to{transform:translateX(-100%)}}
${S} .hx-st-flow{display:flex;width:max-content;margin-top:28px;pointer-events:none;user-select:none}
${S} .hx-st-flow span{--font-body-ja:var(--mono);flex:none;padding-right:.3em;font-weight:600;font-size:clamp(40px,8vw,104px);line-height:1;letter-spacing:.02em;white-space:pre;color:transparent;-webkit-text-stroke:1px rgba(20,35,26,.22);animation:hx-st-flow 160s linear infinite}
@media (prefers-reduced-motion:reduce){${S} .hx-st-flow span{animation:none}}

@media (max-width:767px){
  /* 見出しの 2 行が 1 行ずつに収まる大きさ (360px で 1 行 11 字) */
  ${S} .hx-h2{font-size:min(29px,7.6vw);letter-spacing:.02em}
  ${S} .hx-st-ans{margin-top:14px;font-size:clamp(18px,4.9vw,20px)}
  ${S} .hx-st-box{margin-top:0}
  ${S} .hx-st-card{gap:10px;padding:14px 16px 16px}
  ${S} .hx-st-c2a{gap:8px}
  ${S} .hx-st-qs li{padding:6px 10px;font-size:13px}
  ${S} .hx-st-row{display:flex;gap:12px;align-items:stretch;margin:12px -20px 0;padding:0 20px 8px;overflow-x:auto;overflow-y:hidden;overscroll-behavior-x:contain;scroll-snap-type:x mandatory;scroll-padding-left:20px;scrollbar-width:none}
  ${S} .hx-st-row::-webkit-scrollbar{display:none}
  ${S} .hx-st-row>.hx-st-card{flex:none;width:84vw;max-width:420px;scroll-snap-align:start}
  ${S} .hx-st-c2{display:flex;align-items:stretch}
  ${S} .hx-st-c2>.hx-st-prog{align-self:stretch}
  ${S} .hx-st-to{align-self:center;transform:rotate(90deg);width:26px;height:26px}
  ${S} .hx-st-flow{margin-top:16px}
  /* 隣の札が行の高さを決める。03 は余りを 3 つの手順の札に回し、手順と下の「積み上げる」の間に空白を作らない */
  ${S} .hx-st-steps{flex:1 1 auto}
  ${S} .hx-st-steps li{justify-content:center}
  ${S} .hx-st-flow span{font-size:36px}
}
`;
